import React, {useState} from 'react';
import axios from 'axios';
import { API_BASE_URL, fetchData, IconButton} from './Common';
import './TableViewer.css';
import { ReactComponent as CopyIcon } from '../icons/home/copy.svg';
import { ReactComponent as SaveIcon } from '../icons/home/save.svg';
import { ReactComponent as TrashIcon } from '../icons/home/trash.svg';
import { ReactComponent as ExportIcon } from '../icons/home/export.svg';
import { ReactComponent as PlusIcon } from '../icons/plus.svg';
import { ReactComponent as MinusIcon } from '../icons/minus.svg';


function TableViewer({ tableColumnData,setIsDuplicating,setSpinnerMessage, setTableColumnData, isTablesLoaded, setIsTableColumnDataLoaded, setTables, tables, selectedTableId, onSave, onDuplicate, onExport, onDelete, projectId }) {

  const [selectedColumnId, setSelectedColumnId] = useState(null);
  const [pivotColumnId, setPivotColumnId] = useState(null);
  const [groupingColumnId, setGroupingColumnId] = useState(null);
  const [grouping, setGrouping] = useState(true);
  const [method, setMethod] = useState(null);
  const [customValue, setCustomValue] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [secondColumnId, setSecondColumnId] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState('+');
  const [customValueTab, setCustomValueTab] = useState(true); // true = "Operações com números", false = "Operações entre colunas"
  // Track dropdown open/close state
const [showColumnDropdown, setShowColumnDropdown] = useState(false);
const [showOperatorDropdown, setShowOperatorDropdown] = useState(false);
const [showSecondColumnDropdown, setShowSecondColumnDropdown] = useState(false);



  const table= tables[selectedTableId];

  const [columnTitles, setColumnTitles] = useState(
    table.columns.reduce((acc, column) => {
      acc[column.column_id] = column.column_name;
      return acc;
    }, {})
  );

  const [tableTitle, setTableTitle] = useState(table.table_name);

  let rowIds=[];

  const handleDataChange = (newValue, columnId, rowIndex, rowId) => {

    const updatedData = { ...tableColumnData };  // Create a copy of the current state
    updatedData[columnId].data[rowIndex] = newValue; // Update the specific cell value
    setTableColumnData(updatedData); // ONLY FOR SPECIAL COLUMN AUTO-UPDATE

  // Make an API call to update the data in the database
    axios.post(`${API_BASE_URL}/update-data`, {
      columnId,
      rowId: rowId,
      newData: newValue
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => {
      console.log('Data updated successfully:', response.data);
    })
    .catch(error => {
      console.error('Error updating data:', error);
    });
  };

  const addNewRow = (rowId) => {

    const newRowData = {}; // Object to store data for the new row

    table.columns.forEach(column => {
    newRowData[column.column_id] = '';
  });

    // Make an API request to add the new row
    axios.post(`${API_BASE_URL}/add-row`, {
      rowData: newRowData,
      previousRowId: rowId
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => {
      console.log('Row added successfully:', response.data);

      fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsLoaded, 'columnData');
    })
    .catch(error => {
      console.error('Error adding row:', error);
    });

  };

  const removeRow = (rowId, rowin) => {

    // Create a copy of the current state
    const updatedData = { ...tableColumnData };

    // Remove the row at the specified index for each column
    Object.keys(updatedData).forEach(columnId => {
      updatedData[columnId].data.splice(rowin, 1);
      updatedData[columnId].row_id.splice(rowin, 1);
    });

    // Update the state with the new data
    setTableColumnData(updatedData);

    // Make an API call to remove the row from the database
  axios.post(`${API_BASE_URL}/remove-row`, {
    rowId: rowId,
    columnIds: table.columns.map(column => column.column_id)
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
  .then(response => {
    console.log('Row removed successfully from the database:', response.data);
  })
  .catch(error => {
    console.error('Error removing row from the database:', error);
  });
};

  const removeColumn = (columnId) => {

  const updatedTable = { ...table, columns: table.columns.filter(column => column.column_id !== columnId) };
    const updatedTables = { ...tables, [selectedTableId]: updatedTable };
    setTables(updatedTables);

  // Make an API call to remove the column from the database
  axios.post(`${API_BASE_URL}/remove-column`, {
    columnId: columnId
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
  .then(response => {
    console.log('Column removed successfully from the database:', response.data);
  })
  .catch(error => {
    console.error('Error removing column from the database:', error);
  });
};

  const handleTitleChange = (newTitle, columnId) => {
    setColumnTitles(prevTitles => ({
      ...prevTitles,
      [columnId]: newTitle,
    }));

    axios.post(`${API_BASE_URL}/update-column-title`, {
      columnId,
      newTitle,
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      }
    })
      .then(response => {
        console.log('Column title updated successfully:', response.data);
      })
      .catch(error => {
        console.error('Error updating column title:', error);
      });
  };

  const addNewColumn = (columnId, columnName, formula) => {

    const newColumnName = columnName || prompt('Enter the name for the new column:');

    if (!newColumnName) return;

    axios.post(`${API_BASE_URL}/add-column`, {
      tableId: table.table_id,
      previousColumnId: columnId,
      columnName: newColumnName,
      formula:formula,
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      }
    })
      .then(response => {
        console.log('Column added successfully:', response.data);

        const newColumnId = response.data.columnId;

        fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsLoaded, 'columnData');

        fetchData(`${API_BASE_URL}/tables/${projectId}`, setTables, setIsLoaded, 'tables');

        setColumnTitles(prevTitles => ({
          ...prevTitles,
          [newColumnId]: newColumnName,
        }));
      })
      .catch(error => {
        console.error('Error adding column:', error);
      });
  };

  const handleTableTitleChange = (newTitle) => {
    setTableTitle(newTitle);

    axios.post(`${API_BASE_URL}/update-table-title`, {
      tableId: table.table_id,
      newTitle,
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      }
    })
    .then(response => {
      console.log('Table title updated successfully:', response.data);
    })
    .catch(error => {
      console.error('Error updating table title:', error);
    });
  };

  const InputCell = ({ value, columnId, rowIndex, rowId, onUpdate, tablePermission }) => {
  const [localValue, setLocalValue] = useState(value);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlur = () => {
    if (tablePermission !== 'read-only') {
      onUpdate(localValue, columnId, rowIndex, rowId);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && tablePermission !== 'read-only') {
      onUpdate(localValue, columnId, rowIndex, rowId);
    }
  };

  return (
    <input
      className="input-textbox"
      type="text"
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      style={{
        cursor: tablePermission === 'read-only' ? 'not-allowed' : 'text',
        //opacity: tablePermission === 'read-only' ? 0.5 : 1                // Change opacity if read-only
      }}
      disabled={tablePermission === 'read-only'}  // Disable input if read-only
    />
  );
};

  const InputCellColumnTitles = ({ value, columnId, onUpdate, tablePermission }) => {
  const [localValue, setLocalValue] = useState(value);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlur = () => {
    if (tablePermission !== 'read-only') {
      onUpdate(localValue, columnId);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && tablePermission !== 'read-only') {
      onUpdate(localValue, columnId);
    }
  };


  return (
    <input
      className="input-textbox"
      type="text"
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      style={{
        cursor: tablePermission === 'read-only' ? 'not-allowed' : 'text',  // Change cursor if read-only
        //opacity: tablePermission === 'read-only' ? 0.5 : 1                // Change opacity if read-only
      }}
      disabled={tablePermission === 'read-only'}  // Disable input if read-only
    />
  );
};

  const InputCellTitle = ({ value, onUpdate, tablePermission }) => {
  const [localValue, setLocalValue] = useState(value);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlur = () => {
    if (tablePermission !== 'read-only') {
      onUpdate(localValue);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && tablePermission !== 'read-only') {
      onUpdate(localValue);
    }
  };

  return (
    <input
      className="table-title-input"
      type="text"
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      style={{
        cursor: tablePermission === 'read-only' ? 'not-allowed' : 'text',
        //opacity: tablePermission === 'read-only' ? 0.5 : 1
      }}
      disabled={tablePermission === 'read-only'}  // Disable input if read-only
    />
  );
};


  const HealthDataTable = ({ tableData }) => {
    const columns = tableData.columns;

    // Sort columns by column_order before rendering
  columns.sort((a, b) => a.column_order - b.column_order);

    const getColumnData = columnId => {
      return tableColumnData[columnId] ? tableColumnData[columnId].data : [];
    };

    const firstColumnId = columns[0].column_id;
rowIds = tableColumnData[firstColumnId]?.row_id || [];



const handleTransposeColumnSelect = async (columnId) => {

  try {
    setSpinnerMessage('A Agrupar...');
    setIsDuplicating(true); // Set the flag to indicate duplication process started

    const token = localStorage.getItem('token');
    const response = await axios.post(`${API_BASE_URL}/transpose/${selectedTableId}`,
  {
    pivotColumnId: pivotColumnId,
    groupingColumnId: groupingColumnId,
    grouping: grouping,
    method: method,
    columnId: columnId
  }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

  const transposedItem = response.data[`transposedTable`];
  setTables({...tables, ...transposedItem});

  setIsDuplicating(false);
  setSpinnerMessage(null);

  } catch (error) {
    setIsDuplicating(false);
    setSpinnerMessage(null);
    console.error(`Error transposing`, error);
  }

  fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsTableColumnDataLoaded, 'columnData');

    setPivotColumnId(null);
    setGroupingColumnId(null);
    setShowModal2(false);
};

    return (
      <>
      <div className="project-info">
            <span>{""}</span>
<div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
<button
  className="action-button"
  onClick={() => setShowModal2(true)}
  disabled={table.permission === "read-only"}
>
  <svg
    className="action-button-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-hidden="true"
  >
    <path d="M0 2.28571C0 1.025 1.025 0 2.28571 0H13.7143C14.975 0 16 1.025 16 2.28571V13.7143C16 14.975 14.975 16 13.7143 16H2.28571C1.025 16 0 14.975 0 13.7143V2.28571ZM2.28571 4.57143V13.7143H6.85714V4.57143H2.28571ZM13.7143 4.57143H9.14286V13.7143H13.7143V4.57143Z" />
  </svg>
Agrupar
</button>

<button
  className="action-button"
  onClick={() => setShowModal(true)}
  disabled={table.permission === "read-only"}
>
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
>
  <rect x="2" y="1" width="12" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
  <rect x="4" y="3" width="8" height="2" fill="currentColor"/>
  <rect x="4" y="6" width="2" height="2" fill="currentColor"/>
  <rect x="7" y="6" width="2" height="2" fill="currentColor"/>
  <rect x="10" y="6" width="2" height="2" fill="currentColor"/>
  <rect x="4" y="9" width="2" height="2" fill="currentColor"/>
  <rect x="7" y="9" width="2" height="2" fill="currentColor"/>
  <rect x="10" y="9" width="2" height="2" fill="currentColor"/>
  <rect x="4" y="12" width="8" height="2" fill="currentColor"/>
</svg>

Calcular
</button>
</div>











      {showModal2 && (
        <div className="modal_formula">
          <div className="modal_formula-content">
            <span className="close_formula"
            onClick={() => {
              setPivotColumnId(null);
              setGroupingColumnId(null);
              setMethod(null);
              setShowModal2(false);
            }}
    >&times;</span>

{!pivotColumnId && (
  <>
            <h4>Selecione a primeira coluna</h4>
            <p className="modal-subtitle">Escolha a coluna que será usada como pivot para a operação</p>
            <div className="scrollable-formula-list">
              <ul>
                {Object.keys(columnTitles).map(columnId => (
                  <li key={columnId}>
                    <button onClick={() => {setPivotColumnId(columnId);}}>
                      {columnTitles[columnId]}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
</>

)}

            {pivotColumnId && !groupingColumnId && (
<>
            <h4>Selecione a segunda coluna</h4>
            <p className="modal-subtitle">A coluna selecionada irá agrupar os valores do pivot</p>
<div className="scrollable-formula-list">
  <ul>
    {Object.keys(columnTitles)
  .filter(columnId => columnId !== pivotColumnId)
  .map(columnId => (
    <li key={columnId}>
      <button
        onClick={() => {
          setGroupingColumnId(columnId);
          setGrouping(true);
        }}
      >
        {columnTitles[columnId]}
      </button>
    </li>
  ))}

  </ul>
</div>

</>
            )}

            {pivotColumnId && groupingColumnId && !method && (
<>
            <h4>Selecione a operação que pretende aplicar</h4>
            <p className="modal-subtitle">Selecione como os valores agrupados serão calculados</p>
<div className="scrollable-formula-list">
  <ul>
  {['Soma', 'Média', 'Máximo', 'Mínimo', 'Contagem'].map((label, index) => (
    <li key={index}>
      <button onClick={() => setMethod(index + 1)}>
        {label}
      </button>
    </li>
  ))}
</ul>

</div>

</>
            )}

            {/* Second column selection */}
            {pivotColumnId && groupingColumnId && method && (
              <div>
                <h4>Selecione a última coluna</h4>
                <p className="modal-subtitle">Escolha a coluna numérica que será agregada</p>
                <div className="scrollable-formula-list">
                  <ul>
                    {Object.keys(columnTitles)
  .filter((columnId) => {
    const columnData = tableColumnData[columnId]?.data || [];

    // Keep column if it has at least one valid number
    return columnData.some(
      (value) =>
        value !== null &&
        value !== '' &&
        !isNaN(Number(value))
    );
  })
  .map((columnId) => (
    <li key={columnId}>
      <button onClick={() => handleTransposeColumnSelect(columnId)}>
        {columnTitles[columnId]}
      </button>
    </li>
  ))}

                  </ul>
                </div>
              </div>
            )}

          {/* Step indicators */}
<div className="step-indicators">
  <span className={`step-dot ${true ? 'active' : ''}`} />

  <span
    className={`step-dot ${
      pivotColumnId ? 'active' : ''
    }`}
  />

  <span
    className={`step-dot ${
      pivotColumnId && groupingColumnId ? 'active' : ''
    }`}
  />

  <span
    className={`step-dot ${
      pivotColumnId && groupingColumnId && method ? 'active' : ''
    }`}
  />
</div>

</div>
        </div>
      )}

            </div>

      <div className="table-container">

              <InputCellTitle
                  value={tableTitle}
                  onUpdate={handleTableTitleChange}
                  tablePermission={table.permission}
                />

        <table className="custom-table">
          <thead>

    {/* Row for column management icons ****************************************************/}
    <tr className="icon-row">
    <th className="icon-row"></th> {/* New yellow column */}
      <th className="icon-row">

          <PlusIcon
  onClick={() => {
    if (table.permission !== 'read-only') {
      addNewColumn(null);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',
    opacity: table.permission === 'read-only' ? 0.5 : 1
  }}
  disabled={table.permission === 'read-only'}
/>

      </th> {/* Empty cell for row number */}
      {columns.map(column => (
        <th key={column.column_id} className="icon-row">
          <PlusIcon
  onClick={() => {
    if (table.permission !== 'read-only') {
      addNewColumn(column.column_id);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',  // Grey out if read-only
    marginRight: '10px',
    opacity: table.permission === 'read-only' ? 0.5 : 1                   // Adjust opacity if read-only
  }}
  disabled={table.permission === 'read-only'}  // Disable the button if read-only
/>

<MinusIcon
  onClick={() => {
    if (table.permission !== 'read-only') {
      removeColumn(column.column_id);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',  // Grey out if read-only
    opacity: table.permission === 'read-only' ? 0.5 : 1                   // Adjust opacity if read-only
  }}
  disabled={table.permission === 'read-only'}  // Disable the button if read-only
/>

        </th>
      ))}
    </tr>
{/***** Row for titles ***************************************************************************/}

            <tr className="table-header-row">
<th>

            <PlusIcon
  onClick={() => {
    // Only allow adding a new row if the table permission is not 'read-only'
    if (table.permission !== 'read-only') {
      addNewRow(0);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',  // Grey out if read-only
    marginLeft: '10px',
    opacity: table.permission === 'read-only' ? 0.5 : 1                   // Adjust opacity if read-only
  }}
  disabled={table.permission === 'read-only'}  // Disable the button if read-only
/>


</th>
<th className="table-header-cell">#</th> {/* Add header for row numbers */}

            {columns.map(column => (

<th key={column.column_id} className="table-header-cell">

                  <InputCellColumnTitles
                  value={columnTitles[column.column_id]}
                  columnId={column.column_id}
                  onUpdate={handleTitleChange}
                  tablePermission={table.permission}
                />
                </th>
              ))}
            </tr>
{/***************************************************************************************/}
          </thead>
          <tbody>

          {rowIds.map((rowId, rowIndex) => (
  <tr key={rowId} className="table-row">
<td>
<div style={{ display: 'flex', alignItems: 'center' }}>
            <PlusIcon
  onClick={() => {
    // Only allow adding a new row if the table permission is not 'read-only'
    if (table.permission !== 'read-only') {
      addNewRow(rowId);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',  // Grey out if read-only
    marginRight: '10px',
    opacity: table.permission === 'read-only' ? 0.5 : 1                   // Adjust opacity if read-only
  }}
  disabled={table.permission === 'read-only'}  // Disable the button if read-only
/>

<MinusIcon
  onClick={() => {
    // Only allow removing a row if the table permission is not 'read-only'
    if (table.permission !== 'read-only') {
      removeRow(rowId, rowIndex);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',  // Grey out if read-only
    opacity: table.permission === 'read-only' ? 0.5 : 1                   // Adjust opacity if read-only
  }}
  disabled={table.permission === 'read-only'}  // Disable the button if read-only
/>

              </div>
</td>
<td className="table-cell">{rowIndex + 1}</td> {/* Add row number */}
                {columns.map(column => (
                  <td key={column.column_id} className="table-cell">

                <InputCell
                  value={getColumnData(column.column_id)[rowIndex] || ''}
                  columnId={column.column_id}
                  rowIndex={rowIndex}
                  rowId={rowId}
                  onUpdate={handleDataChange}
                  tablePermission={table.permission}
                />
                  </td>
                ))}


              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </>
    );
  };

  const handleSecondColumnSelect = (secondColId) => {
  if ((!selectedColumnId && !customValue) || !selectedOperator || !secondColId) return;

  // First part: either custom value or selected column
  const firstPart = customValue ? customValue : 'C' + selectedColumnId;

  // Second part: the selected second column
  const secondPart = 'C' + secondColId;

  // Column name for display
  const newColumnName = `⭐ ${customValue ? customValue : columnTitles[selectedColumnId]} ${selectedOperator} ${columnTitles[secondColId]}`;

  // Formula string for backend
  const formula = firstPart + selectedOperator + secondPart;

  addNewColumn(
    tables[selectedTableId].columns[tables[selectedTableId].columns.length - 1].column_id,
    newColumnName,
    formula
  );

  // Reset modal
  setSelectedColumnId(null);
  setSelectedOperator(null);
  setSecondColumnId(null);
  setCustomValue('');
  setShowModal(false);
};

  return (<>
    {showModal && (
  <div className="modal_formula">
    <div className="modal_formula-content">
      {/* Close button */}
      <span
        className="close_formula"
        onClick={() => {
          setSelectedColumnId(null);
          setSecondColumnId(null);
          setSelectedOperator(null);
          setCustomValue('');
          setCustomValueTab(true);
          setShowModal(false);
        }}
      >
        &times;
      </span>

      <h3>Selecione o tipo de operação</h3>

      {/* Tab header */}
      <div className="tab-header">
        <button
          className={`tab ${customValueTab ? 'active' : ''}`}
          onClick={() => setCustomValueTab(true)}
        >
          Operações com números
        </button>
        <button
          className={`tab ${!customValueTab ? 'active' : ''}`}
          onClick={() => setCustomValueTab(false)}
        >
          Operações entre colunas
        </button>
      </div>

      {/* Tab content */}
      <div className="tab-content">
        <div className="modal-row">
          {customValueTab ? (
            <input
              type="number"
              placeholder="Insira um número"
              value={customValue}
              onChange={(e) => setCustomValue(e.target.value)}
            />
          ) : (
            <div className="custom-select">
              <div className="selected" onClick={() => setShowColumnDropdown((prev) => !prev)}>
                {selectedColumnId ? columnTitles[selectedColumnId] : 'Coluna 1'}
                <span className="arrow">&#9662;</span>
              </div>
              {showColumnDropdown && (
                <div className="options">
                  {Object.keys(columnTitles).map((columnId) => (
                    <div
                      key={columnId}
                      className="option"
                      onClick={() => {
                        setSelectedColumnId(columnId);
                        setShowColumnDropdown(false);
                      }}
                    >
                      {columnTitles[columnId]}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          <div className="custom-select">
            <div className="selected" onClick={() => setShowOperatorDropdown((prev) => !prev)}>
              {selectedOperator || '+'}
              <span className="arrow">&#9662;</span>
            </div>
            {showOperatorDropdown && (
              <div className="options">
                {['+', '-', '*', '/'].map((operator) => (
                  <div
                    key={operator}
                    className="option"
                    onClick={() => {
                      setSelectedOperator(operator);
                      setShowOperatorDropdown(false);
                    }}
                  >
                    {operator}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="custom-select">
            <div className="selected" onClick={() => setShowSecondColumnDropdown((prev) => !prev)}>
              {secondColumnId ? columnTitles[secondColumnId] : 'Coluna 2'}
              <span className="arrow">&#9662;</span>
            </div>
            {showSecondColumnDropdown && (
              <div className="options">
                {Object.keys(columnTitles).map((columnId) => (
                  <div
                    key={columnId}
                    className="option"
                    onClick={() => {
                      setSecondColumnId(columnId);
                      setShowSecondColumnDropdown(false);
                    }}
                  >
                    {columnTitles[columnId]}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Finish Button */}
        <button
          className="finish-button"
          disabled={
            customValueTab
              ? !customValue || !selectedOperator || !secondColumnId
              : !selectedColumnId || !selectedOperator || !secondColumnId
          }
          onClick={() => handleSecondColumnSelect(secondColumnId)}
        >
          Criar Coluna de Operação
        </button>
      </div>
    </div>
  </div>
)}
    <div>
      <HealthDataTable tableData={table} />
    </div>
    </>
  );
}

export default TableViewer;
